<div class="dialog">
  <header class="dialog__header">
    <ci-icon 
      class="dialog__icon"
      [class.success]="iconName() === 'success'"
      [class.warning]="iconName() === 'warning'"
      [class.error]="iconName() === 'error'"
      type="svg" 
      [name]="iconName()"
      scale="1.5x"
    ></ci-icon>
      
    <h2 
      class="dialog__title ci-subheading-semibold"
      [class.no-icon]="!iconName()"
    >
      {{ getTitleDialog() | translate }}
    </h2>
  </header>
 
  @if (getContentString()) {
    <main class="dialog__main">
      <p 
        [innerHTML]="getContentString() | translate"
        class="main__text ci-paragraph-p1-regular"
      ></p>
    </main>
  }

  @if (getContentDialogSuccessErrorEditRouteResponse()) {
    <main class="dialog__main">
      @if(isOnlyErrorList()) {
        <p class="main__text ci-paragraph-p1-regular">
          {{ 'Lo sentimos, no se ha podido modificar la ruta con los parámetros introducidos' | translate }}.
        </p>
        
        <div class="main__item-list-wrapper">
          <p class="ci-paragraph-p1-regular">
            <strong>{{ 'Motivos' | translate }}</strong>
          </p>
          <ci-scroll-fade height="300px">
            <ul class="main__item-list">
              @for (error of getErrorList(); track error.id) {
                <li class="ci-paragraph-p1-regular main__item">
                  {{ error.motive }}
                </li>
              }
            </ul>
          </ci-scroll-fade>
        </div>
      } @else {
        <div class="main__text-wrapper">
          <p class="main__text ci-paragraph-p1-regular">
            {{ ('Se han modificado correctamente' | translate) + ' ' + getSuccessList().length + ' ' + ('recursos' | translate) }}.  
          </p>
          <p class="main__text ci-paragraph-p1-regular">
            {{ ('Otros' | translate) + ' ' + getErrorList().length + ' ' + ('recursos no se pudieron modificar' | translate) }}.
          </p>
        </div>
        
        <div class="main__item-list-wrapper">
          <p class="ci-paragraph-p1-regular">
            <strong>{{ 'Motivos' | translate }}</strong>
          </p>
          <ci-scroll-fade height="300px">
            <ul class="main__item-list">
              @for (error of getErrorList(); track error.id) {
                <li class="ci-paragraph-p1-regular main__item">
                  {{ error.motive }}
                </li>
              }
            </ul>
          </ci-scroll-fade>
        </div>
      }
    </main>
  }

  @if (data.handleClickPrimaryButton || data.handleClickSecondaryButton) {
    <footer class="dialog__footer">
      @if (data.secondaryActionButtonText) {
        <ci-text-button 
          class="dialog__secondary-text-button"
          class-name="ci-text-btn-primary-s" 
          type="button" 
          [attr.aria-label]="data.secondaryActionButtonText | translate"
          (click)="data.handleClickSecondaryButton()"
        >
          {{ data.secondaryActionButtonText | translate }}
        </ci-text-button>
      }
        
      @if (data.handleClickPrimaryButton) {
        <ci-text-button 
          class="dialog__primary-text-button"
          class-name="ci-text-btn-primary-s" 
          type="button" 
          [attr.aria-label]="data.primaryActionButtonText | translate"
          (click)="data.handleClickPrimaryButton()"
        >
          {{ data.primaryActionButtonText| translate }}
        </ci-text-button>
      }
    </footer>
  }
</div>